// Debugging confirmation
console.log('✅ router-routes-manager.js aka Routes File Loaded!');

// router‑routes‑manager.js
import { myFetchJsonContent } from './utils-fetch-data-json.js';

//// Global Route Mappings (will become a Proxy)
export let routeMappings = {};

let _rawRoutes = null; // the Proxy from loadRoutes()
let _routesForLang = null; // the per‑language Proxy

// wrap the raw JSON in a (key → lang → slug‑or‑key) Proxy
function makeRouteProxy(data) {
  return new Proxy(data, {
    get(target, prop) {
      // missing key? return a Proxy so ANY [lang] still returns 'key'
      if (!(prop in target)) {
        return new Proxy(
          {},
          {
            get(_, innerLang) {
              return typeof innerLang === 'string' ? prop : undefined;
            },
          }
        );
      }
      // existing key: wrap its object so [lang] → mapping or fallback to key
      return new Proxy(target[prop], {
        get(t2, lang) {
          return typeof lang === 'string' ? t2[lang] ?? prop : undefined;
        },
      });
    },
  });
}

//// wrap a plain routes object in a Proxy
//function makeRouteProxy(data) {
//    return new Proxy(data, {
//        get(target, prop) {
//            // for any missing key, just return a no‑op mapping object
//            if (!(prop in target)) {
//                return new Proxy({}, {
//                    get(_, innerProp) {
//                        // accessing missingLang on missingKey → fall back to `${key}`
//                        return typeof innerProp === "string" ? innerProp : undefined;
//                    }
//                });
//            }
//            // if key exists, wrap that mapping in another proxy so missing lang → returns key
//            return new Proxy(target[prop], {
//                get(t2, lang) {
//                    return typeof lang === "string"
//                        ? (t2[lang] ?? prop)   // routeMappings[key][lang] or fall back to `key`
//                        : undefined;
//                }
//            });
//        }
//    });
//}

//// wrap the raw JSON in a (key → lang → slug‑or‑key) Proxy
//function makeRouteProxy(data) {
//  return new Proxy(data, {
//    get(target, prop) {
//      // missing key? return a Proxy so ANY [lang] still returns 'key'
//      if (!(prop in target)) {
//        return new Proxy({}, {
//          get(_, innerLang) {
//            return typeof innerLang === "string" ? prop : undefined;
//          }
//        });
//      }
//      // existing key: wrap its object so [lang] → mapping or fallback to key
//      return new Proxy(target[prop], {
//        get(t2, lang) {
//          return typeof lang === "string"
//            ? (t2[lang] ?? prop)
//            : undefined;
//        }
//      });
//    }
//  });
//}

export async function loadRoutes() {
  if (_rawRoutes) return _rawRoutes;
  try {
    const data = await myFetchJsonContent('data/routes-and-translated-links.json');
    const clean = data && typeof data === 'object' ? data : {};
    _rawRoutes = makeRouteProxy(clean);
    routeMappings = _rawRoutes; // keep this for backwards use
  } catch (e) {
    console.error('❌ Error loading routes:', e);
    _rawRoutes = makeRouteProxy({});
    routeMappings = _rawRoutes;
  }
  return _rawRoutes;
}

/**
 * Initialize a per‑language mapper.
 * After this, you can do:
 *
 *   await initLinksTranslator("en");
 *   const { keyAboutUs: linkAboutUs, keyBlog: linkBlog } = _routesForLang;
 *
 * and each value is already the full `lang/slug` string.
 */
export async function initLinksTranslator(lang) {
  const routes = await loadRoutes();
  _routesForLang = new Proxy(routes, {
    get(target, prop) {
      if (typeof prop === 'string') {
        // target[prop][lang] is the slug or the key itself
        return `${lang}/${target[prop][lang]}`;
      }
      return undefined;
    },
  });
  return _routesForLang;
}

/** quick helper if you don’t want destructuring */
export function getLinksTranslationByKeyFromCurrentLanguageProxy(key) {
  if (!_routesForLang) {
    throw new Error('❌ call initLinksTranslator(lang) before tLink()');
  }
  return _routesForLang[key];
}

/** shorthand: ensure loaded then return `lang/key` URL */
export async function getLinksTranslationByKey(key, lang) {
  const routes = await loadRoutes();
  // routes[key][lang] will either be your mapping or `key` itself
  return `${lang}/${routes[key][lang]}`;
}

/** shorthand if you only want the “slug” portion (no leading lang/) */
export async function getLinksTranslationByKeySingleWord(key, lang) {
  const routes = await loadRoutes();
  return routes[key][lang];
}

export function setRouteMappings(routes) {
  if (routes && typeof routes === 'object') {
    routeMappings = routes;
    console.log('✅ Preloaded routes set successfully.');
  } else {
    console.warn('⚠️ Invalid route mappings passed to setRouteMappings.');
  }
}

//// Utility Function: Check if routes are already loaded
function areRoutesLoaded() {
  return routeMappings && Object.keys(routeMappings).length > 0;
}

export async function ensureRoutesLoaded(retries = 5, delay = 500) {
  for (let attempt = 1; attempt <= retries; attempt++) {
    if (areRoutesLoaded()) {
      console.log('✅ Routes are already loaded.');
      return;
    }

    console.warn(`⚠️ Routes not loaded yet, attempt ${attempt}/${retries}...`);
    try {
      await loadRoutes();
      if (areRoutesLoaded()) {
        console.log('✅ Routes successfully loaded on attempt', attempt);
        return;
      }
    } catch (error) {
      console.error(`❌ Attempt ${attempt} failed to load routes:`, error.message);
    }

    // Wait before retrying
    await sleep(delay);
  }

  console.error('❌ 404 Failed to load routes after multiple attempts.');
  routeMappings = { '404': { 'folder-path': 'errors' } }; // Fallback route
}

///**
// * Get the translation key for a given page URL
// * @param {string} pageURL - The page URL to find the translation key for
// * @returns {string|null} - The matched translation key or null if not found
// */
export async function GetPageTranslateKeyPageURL(pageURL) {
  if (!pageURL) return null;

  try {
    await ensureRoutesLoaded();

    pageURL = pageURL.trim().toLowerCase();
    if (!areRoutesLoaded()) {
      console.warn('⚠️ No route mappings available.');
      return null;
    }

    const matchedKey = Object.keys(routeMappings).find(key => {
      const translations = routeMappings[key];
      return Object.values(translations).some(
        value => typeof value === 'string' && value.toLowerCase().trim() === pageURL
      );
    });

    if (matchedKey) {
      console.log(`✅ Translation key found for page URL "${pageURL}":`, matchedKey);
    } else {
      console.warn(`⚠️ No translation key found for page URL: ${pageURL}`);
    }

    return matchedKey || null;
  } catch (error) {
    console.error('❌ Error finding translation key for page URL:', error.message);
    return null;
  }
}
